export default "__VITE_ASSET__DrIiRF28__"